export default __webpack_public_path__ + "static/media/cardIcon_profile_active.2b7b0762.svg";